import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import { PORTAL_ACRONYMS } from '@mfe-types/portal';

let datadogBrowserRumPromise: Promise<any> | null = null;

export const initDatadog = async (portal: Portal) => {
    const currentEnv = process.env.NX_TASK_TARGET_CONFIGURATION ?? 'development';

    if (!datadogBrowserRumPromise) {
        datadogBrowserRumPromise = new Promise((resolve, reject) => {
            import(/* webpackChunkName 'datadog-browser-rum'*/ '@datadog/browser-rum')
                .then(({ datadogRum }) => {
                    datadogRum.init({
                        applicationId: process.env.NX_DATADOG_APP_ID as string,
                        clientToken: process.env.NX_DATADOG_CLIENT_TOKEN as string,
                        site: 'datadoghq.eu',
                        service: 'wlef',
                        env: `${PORTAL_ACRONYMS[portal]}_${currentEnv}`,
                        version: process.env.NX_APP_VERSION,
                        sessionSampleRate: 100,
                        sessionReplaySampleRate: 20,
                        trackUserInteractions: true,
                        trackResources: true,
                        trackLongTasks: true,
                        defaultPrivacyLevel: 'mask-user-input',
                    });
                    datadogRum.startSessionReplayRecording();
                    resolve(datadogRum);
                })
                .catch((e) => {
                    console.warn(e);
                    reject(e);
                });
        });
    }
    return datadogBrowserRumPromise;
};

export const addError = async (error: unknown, context?: object | undefined) => {
    const datadogBrowserRum = await datadogBrowserRumPromise;
    datadogBrowserRum?.addError(typeof error === 'string' ? new Error(error) : error, context);
};
